import { render, staticRenderFns } from "./Music.vue?vue&type=template&id=da7841b0&"
import script from "./Music.vue?vue&type=script&lang=ts&"
export * from "./Music.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports